import styles from './style.module.scss';
import React from 'react';

const JobsSkeleton: React.FC = () => {
    return (
        <div className={styles.wrapper}>
            {[1, 2, 3, 4, 5, 6].map((_, i) => (
                <div className={styles.jobCard} key={i}>
                    <div className={styles.jobLeft}>
                        <div className={styles.logo}></div>
                        <div className={styles.jobInfo}>
                            <div className={styles.lineShort}></div>
                            <div className={styles.line}></div>
                            <div className={styles.line}></div>
                        </div>
                    </div>
                    <div className={styles.actions}>
                        <div className={styles.button}></div>
                        <div className={styles.button}></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default JobsSkeleton;
